import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import {FormControl, FormHelperText} from 'material-ui/Form';
import Input, {InputLabel} from 'material-ui/Input';
import {LinearProgress} from 'material-ui/Progress';
import {withStyles} from 'material-ui/styles';
import DeleteIcon from 'material-ui-icons/Delete';
import IconButton from 'material-ui/IconButton';
import red from 'material-ui/colors/red';
import green from 'material-ui/colors/green';
import grey from 'material-ui/colors/grey';

const styles = theme => ({
	dropzone: {
		display: 'inline-flex',
		flexDirection: 'column',
		cursor: 'pointer'
	},
	active: {
		backgroundColor: grey[100]
	},
	accept: {
		backgroundColor: green[100]
	},
	uploaded: {
		color: green[900]
	},
	reject: {
		backgroundColor: red[100]
	},
	valueContainer: {
		display: 'flex',
		flexFlow: 'row nowrap',
		margin: 0,
		padding: 0
	},
	deleteButton: {
		height: 'auto'
	},
	progress: {
		marginTop: -(theme.spacing.unit * 2) - 6,
		width: '100%'
	}
});

const FileField = props => {
	const {accept = '*/*', onDrop, classes} = props;
	const {value, name, label} = props;
	const {
		handleDeleteFile,
		disabled,
		error,
		fullWidth,
		margin,
		required,
		helperText
	} = props;
	const {progress, status} = props;

	const formControlProps = {
		disabled,
		error,
		fullWidth,
		margin,
		required
	};

	if (status === 'SUCCESS') {
		classes.title = classes.uploaded;
	}

	function isPending() {
		return status === 'PENDING';
	}

	return (
		<FormControl {...formControlProps}>
			<div className={classes.valueContainer}>
				<Dropzone
					accept={accept}
					onDrop={onDrop}
					multiple={false}
					disabled={disabled}
					disablePreview
					className={classes.dropzone}
					activeClassName={classes.active}
					acceptClassName={classes.accept}
					rejectClassName={classes.reject}
				>
					<InputLabel>
						{label}
					</InputLabel>
					<Input
						className={classes.title}
						value={value}
						name={name}
						readOnly
					/>
					{helperText && (
						<FormHelperText>
							{helperText}
						</FormHelperText>
					)}
				</Dropzone>
				<IconButton
					className={classes.deleteButton}
					disabled={value === '' || isPending()}
					onClick={handleDeleteFile}
				>
					<DeleteIcon/>
				</IconButton>
			</div>
			{isPending() && (
				<LinearProgress
					className={classes.progress}
					mode="determinate"
					color="accent"
					value={progress}
				/>
			)}
		</FormControl>
	);
};

FileField.defaultProps = {
	accept: '*/*',
	disabled: false
};

FileField.propTypes = {
	accept: PropTypes.string,
	onDrop: PropTypes.func.isRequired,
	handleDeleteFile: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	value: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
	error: PropTypes.bool,
	fullWidth: PropTypes.bool,
	required: PropTypes.bool,
	margin: PropTypes.string,
	helperText: PropTypes.string,
	progress: PropTypes.number,
	status: PropTypes.string
};

export default withStyles(styles)(FileField);



// WEBPACK FOOTER //
// ./src/client/components/admin/common/form/file-field/file-field.jsx